export const AVAILABILITY = {
  available_now: {
    label: 'Available now',
    color: '#004D35',
    bg: '#a8f0c6',
    dot: '#004D35',
  },
  available_this_week: {
    label: 'This week',
    color: '#7a5a00',
    bg: '#ffd97d',
    dot: '#7a5a00',
  },
  limited: {
    label: 'Limited',
    color: '#555',
    bg: '#e0ddd8',
    dot: '#999',
  },
};

export const CANONICAL_SLUGS = Object.keys(AVAILABILITY);

export function getAvailability(slug) {
  return AVAILABILITY[slug] || AVAILABILITY.limited;
}

export function normalizeSlug(raw) {
  if (!raw) return 'available_now';
  if (CANONICAL_SLUGS.includes(raw)) return raw;
  if (raw === 'available' || raw === 'now' || raw === 'Available now') return 'available_now';
  if (raw === 'this-week' || raw === 'this_week' || raw === 'week' || raw === 'Available this week') return 'available_this_week';
  return 'limited';
}
